(function($){
    function pullman_bercy_initializeMapGroup(div){
        if (typeof(div) === "undefined") div = "map-canvas";
        if (typeof(bounds) === "undefined" && map_config.set_bounds) bounds = new google.maps.LatLngBounds();

        var marker, i;
        var center = [map_config.markers[0].latitude, map_config.markers[0].longitude];

        map = new google.maps.Map(document.getElementById(div), {
            // scroll wheel
            scrollwheel: false,
            //zoom
            // zoom: 2,
            zoom: map_config.map_zoom,
            zoomControlOptions: {
                position: google.maps.ControlPosition[map_config.zoom_control_position]
            },
            //position
            center: new google.maps.LatLng(center[0], center[1]),
            //map type
            mapTypeId: google.maps.MapTypeId[map_config.map_type],
            mapTypeControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT,
                style: google.maps.MapTypeControlStyle.DEFAULT
            },
            panControl: false,
            panControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            scaleControl: false,
            streetViewControlOptions: {
                position: google.maps.ControlPosition.TOP_RIGHT
            }

        });


        for (i = 0; i < map_config.markers.length; i++) {

            var infowindow = new google.maps.InfoWindow();

            var width = (i === 0)? 60 : 41;
            var height = (i === 0)? 80 : 50;
            // var width = (i === 0)? 80 : 41;
            // var height = (i === 0)? 100 : 50;
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(map_config.markers[i].latitude, map_config.markers[i].longitude),
                map: map,
                icon : {
                    url		: map_config.markers[i].icon_hotel,
                    scaledSize: new google.maps.Size(height, width)
                },
                id_poi: map_config.markers[i].id_poi.toString(),
                poi_title: map_config.markers[i].title.toString(),
                html: map_config.markers[i].html,
                destination: map_config.markers[i].destination.toString(),
                zIndex: 0,
                visible: true
            });

            markers[map_config.markers[i].id_poi] = marker;

            bounds.extend(marker.position);

            if(! $('body').hasClass('home')){ //homepage not clickable

                google.maps.event.addListener(marker, 'click', (function (marker, i) {
                    return function () {
                        var icon_colored = {url: map_config.icon_colored, scaledSize: new google.maps.Size(41, 50)};
                        var icon_default = {url: map_config.icon_small, scaledSize: new google.maps.Size(41, 50)};


                        for (i = 1; i < map_config.markers.length; i++) {
                            markers[map_config.markers[i].id_poi].setIcon(icon_default);
                        }

                        map.setCenter(marker.getPosition());
                        if(marker.id_poi !== 'hotel'){
                            marker.setIcon(icon_colored);
                        }

                        window.__last_clicked_poi = marker.poi_title;
                        $('.map-canvas').trigger('click_on_single_poi');

                        if (window.hotel_infowindow) {
                            window.hotel_infowindow.close();
                        }
                        if (infowindow) {
                            infowindow.close();
                        }
                        infowindow.setContent(marker.html);
                        infowindow.open(map, marker);
                        var infobox_map = $('.infobox_map');
                        if (infobox_map.length > 0 && !window.is_mobile) {
                            infobox_map.fadeOut();
                        }
                        google.maps.event.addListenerOnce(infowindow, 'closeclick', function () {
                            if (infobox_map.length > 0 && !window.is_mobile) {
                                infobox_map.fadeIn();
                            }
                        });

                    };
                })(marker, i));
            }
        }



        //strt clustering
        var clusterStyles = [{
            textColor: '#000',
            url: theme_url + '/css/images/marker_group.png',
            height: 41,
            width: 41,
            textSize: 16,
            // adjust zIndex to be above other markers
            // zIndex: 9999,
        }];

        var numeric_array = [];
        for ( var item in markers ){
            if(item === 'hotel') continue;
            numeric_array.push( markers[ item ] );
        }

        var markerCluster = new MarkerClusterer(map, numeric_array, {styles: clusterStyles});
        markerCluster.setGridSize(70);


        // map.fitBounds(bounds,{top: 50, right: 50, bottom: 50, left: 50 });

        var listener = google.maps.event.addListener(map, "idle", function() {
            if (map.getZoom() > 16) map.setZoom(16);
            google.maps.event.removeListener(listener);
        });


        //filters makers
        var filters_maps_button = $('#pois_filters input, #select_poi');
        filters_maps_button.change(function(){
            var category = $(this).val();

            //deselect all pins
            var icon_default = {url: map_config.icon_small, scaledSize: new google.maps.Size(41, 50)};

            for (i = 1; i < map_config.markers.length; i++) {
                markers[map_config.markers[i].id_poi].setIcon(icon_default);
            }

            pullman_bercy_filterMarkers(category);
        });

    }

    function pullman_bercy_filterMarkers(category){
        showMarkers(category);
    }


    // Sets the map on all markers in the array.
    function setMapOnAll(category, bounds) {

        var inclusives = [];
        $('#pois_filters input').each( function( i, elem ) {
            if ( elem.checked ) {
                inclusives.push( elem.value );
            }
        });

        Object.keys(markers).forEach(function(i){
            var marker = markers[i];
            var destination = marker.destination;
            if (inclusives.some(v => destination.includes(v))) {
                // There's at least one
                marker.setMap(map);
                bounds.extend(marker.position);
            } else {
                marker.setMap(null);
            }
        });

        map.fitBounds(bounds,{top: 50, right: 50, bottom: 50, left: 50 });
    }

    // Removes the markers from the map, but keeps them in the array.
    function hideMarkers() {
        Object.keys(markers).forEach(function(i){
            markers[i].setMap(null);
        });
    }

    // Shows any markers currently in the array.
    function showMarkers(category) {
        hideMarkers();
        setMapOnAll(category, bounds);
    }


    $(document).ready(function () {

        var map_loaded = false;
        if ($('#map-canvas').length === 0) return false;

        var position_map = $('#map-canvas').offset().top - $('#map-canvas').height() - 200;

        $(window).on("scroll", function() {
            var scrollPosition = window.pageYOffset;
            if(!map_loaded && scrollPosition >= position_map){
                map_loaded = true;
                pullman_bercy_initializeMapGroup();

                $('button[title="Keyboard shortcuts"] , .gmnoprint a, .gm-style-cc a').attr('tabindex', -1);
            }
        });

        $('.see_on_map').click(function(){
            var current_marker = $(this).data('poi');
            google.maps.event.trigger(markers[current_marker], 'click');

            $('html, body').animate({
                scrollTop: $('#map-canvas').offset().top - 100
            }, 500);
        })

    });

})(jQuery);